<div #dropdown="ngbDropdown" ngbDropdown [container]="isBody ? 'body' : null" class="dropdown-group h-100" (blur)="dropdown.close()">
	<div
		ngbDropdownAnchor
		role="button"
		#labelField
		class="form-control dropdown-input border-0 w-100 h-100 d-flex align-items-center justify-content-between"
		[ngClass]="disabled ? 'bg-gray-200 no-pointer' : 'cursor-pointer bg-white'"
		(click)="detectChanges()">
		<div class="d-block text-dark one-line">
			<span [innerHTML]="title"></span>
			@if (!title || title === '') {
				<span class="text-muted">{{ placeholder }}</span>
			}
		</div>
		<img alt="toggle" class="dropdown-img" loading="lazy" src="assets/orca/catalogTree/arrow_down.svg" />
		<div
			class="dropdown-menu overflow-auto"
			[style.width.px]="labelField.clientWidth"
			[class.d-none]="disabled"
			ngbDropdownMenu
			[style.height]="dropdownHeight"
			[style.minHeight.rem]="minHeightDropdown"
			[style.maxHeight]="maxDropdownHeight">
			@for (option of list; track option; let idx = $index) {
				<button
					role="option"
					[ngClass]="model === option.value ? 'bg-primary' : ''"
					tabindex="-1"
					(mousedown)="$event.preventDefault()"
					(click)="$event.preventDefault()"
					(mouseup)="$event.preventDefault(); valueChange(option)"
					class="p-2 dropdown-item d-flex text-dark align-items-center dropdown-item-{{ idx }}">
					@if (!isOptionDisabled(option.value)) {
						<div class="one-line d-block" [innerHTML]="option.key"></div>
					}
					@if (isOptionDisabled(option.value)) {
						<div class="one-line d-block">
							<div class="opacity-3" [innerHTML]="option.key"></div>
						</div>
					}
				</button>
			}
		</div>
	</div>
</div>
